import { useMutation } from '@tanstack/react-query';
import ContractTemplateService from '@clickersphere/core/services/ContractTemplateService';

export function useExtractContractTemplateParagraphs() {
  const {
    isPending: extractParagraphsIsPending,
    mutateAsync: extractParagraphsAsync,
  } = useMutation({
    mutationFn: async (fileKey: string) =>
      ContractTemplateService.extractParagraphs(fileKey),
  });

  return {
    extractParagraphsAsync,
    extractParagraphsIsPending,
  };
}
